import './switch.scss'

import React from 'react'

export default class Switch extends React.Component {
  constructor(...props) {
    super(...props)
    this._ref = React.createRef()
  }

  get checked() {
    return this._ref.current.checked
  }

  set checked(value) {
    this._ref.current.checked = value
  }

  render() {
    return (
      <div className="ui-switch">
        <span className="label">{this.props.text}</span>
        <label className="switch">
          <input
            type="checkbox"
            defaultChecked={this.props.checked}
            ref={this._ref}
            disabled={this.props.disabled}
          />
          <span className="slider"></span>
        </label>
      </div>
    )
  }
}
